import { render, staticRenderFns } from "./GaugeTwoColors.vue?vue&type=template&id=124a57e9&lang=pug"
import script from "./GaugeTwoColors.vue?vue&type=script&lang=js"
export * from "./GaugeTwoColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports